import { Layout, type StackProps, Text } from '@loadsmart/miranda-react'

export type CardInfoItemProps = {
  align?: StackProps['align']
  style?: React.CSSProperties
  title: string
  value?: string
}

export function CardInfoItem({ align = 'flex-start', title, value, ...props }: CardInfoItemProps) {
  return (
    <Layout.Stack gap="spacing-0-5" align={align} {...props}>
      <Text variant="body-sm">{title}</Text>
      <Text variant="body-md">{value}</Text>
    </Layout.Stack>
  )
}
